
function SdFilterComboController() {
    var ctrl = this;

    ctrl.$onInit = function () {

        if (ctrl.filter.selected) {
            ctrl.editSelected = ctrl.filter.selected.slice();
        }
        else {
            ctrl.editSelected = [];
        }

        ctrl.years = [];
    };

    ctrl.$onChanges = function () {
    };

    ctrl.selectOption = function (option, event) {
        ctrl.value = option;
        if (option) {            
            ctrl.toggleSelected(option);
            event.stopPropagation();
        }
    };

    ctrl.stopPropagation = function (event) {
        if (event) {
            event.stopPropagation();
        }
    };

    ctrl.findSelectedIndex = function (option) {
        if (!ctrl.editSelected) {
            return -1;
        }
        for (var i = 0; i < ctrl.editSelected.length; i++) {
            if (ctrl.editSelected[i] === option) {
                return i;
            }
        }
        return -1;
    };

    ctrl.toggleSelected = function (option) {
        var index = ctrl.findSelectedIndex(option);
        if (index >= 0) {
            ctrl.editSelected.splice(index, 1);
        }
        else {
            if (!ctrl.editSelected) {
                ctrl.editSelected = [];
            }
            ctrl.editSelected.push(option);
        }        
    };

    ctrl.clearSelected = function () {
        ctrl.editSelected = [];
    };

    ctrl.isSelected = function (option) {
        return ctrl.findSelectedIndex(option) >= 0;
    };

    ctrl.editAllSelected = function () {
        return ctrl.editSelected.length <= 0;
    };

    ctrl.allSelected = function () {
        return ctrl.filter.selected.length <= 0;
    };

    ctrl.getSelectedText = function () {
        var selStr = '';
        if (ctrl.filter.type === 'date') {
            selStr = 'Datas Selecionadas';
        }
        else {
            for (var i = 0; i < ctrl.filter.selected.length; i++) {
                if (selStr !== '') {
                    selStr += ', ';
                }
                selStr += ctrl.filter.selected[i];
            }
        }
                
        return selStr;
    };

    ctrl.ok = function () {       
        ctrl.filter.included = false;
        ctrl.filter.isOpen = false;

        ctrl.filter.selected = ctrl.editSelected;
        if (ctrl.filter.type == 'date') {
            ctrl.filter.selected = [];
            for (var i = 0; i < ctrl.years.length; i++) {
                for (var j = 0; j < ctrl.years[i].months.length; j++) {
                    for (var k = 0; k < ctrl.years[i].months[j].days.length; k++) {
                        if (ctrl.years[i].months[j].days[k].isChecked) {
                            var date = new Date(Date.UTC(ctrl.years[i].Value, ctrl.years[i].months[j].Value, ctrl.years[i].months[j].days[k].Value));
                            ctrl.filter.selected.push(date);    
                        }
                    }
                }
            }
        }

        ctrl.onSelectOption({
            option: ctrl.value,
            selected: ctrl.editSelected
        });

        if (ctrl.allSelected()) {
            ctrl.filter.changed = false;
        }
    };

    ctrl.cancel = function () {
        if (ctrl.filter.selected) {
            ctrl.editSelected = ctrl.filter.selected;
        }

        console.log('cancel');
        ctrl.filter.included = false;
        ctrl.filter.isOpen = false;
    };

    ctrl.remove = function () {
        if (!ctrl.allSelected()) {
            ctrl.clearSelected();
            ctrl.ok();
        }
        ctrl.filter.included = false;
        ctrl.filter.changed = false;
    };

    ctrl.convertOptions = function () {
        for (var i = 0; i < ctrl.filter.options.length; i++) {
            ctrl.filter.options[i].Value = ctrl.filter.options[i];
        }
    };

}

seedWebApp.component('sdFilterCombo', {
    controller: SdFilterComboController,
    bindings: {
        parent: '<',
        filter: '=',
        isLoading: '=',
        showButtons: '<',
        onSelectOption: '&'
    },
    templateUrl: '/SPA/components/filters/sd-filter-combo.html'
});